export default __webpack_public_path__ + "menu-home-icon.b25fb1cf43ba70e4bd6d1f4125778699.svg";